<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="schedulesList.length == 0">
        <h3>Dowolny termin i godzina</h3>
      </v-col>
      <v-col cols="12" v-if="schedulesList.length > 0">
        <v-data-table
            :items="schedulesList"
            :headers="headers"
            hide-default-footer
            disable-pagination>
          <template v-slot:item="props">
            <tr>
              <td>{{getTermin(props.item)}}</td>
              <td>{{getGodziny(props.item)}}</td>
              <td>{{getDni(props.item)}}</td>
              <td>
                <v-icon small class="mr-2"  @click="deleteItem(props.item)" v-if="!readonly" title="Usuń termin">fa-trash</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="showAddSchedule = true" v-if="!readonly">Dodaj termin</v-btn>
      </v-col>
    </v-row>
    <ReserveAddSchedule :visible="showAddSchedule" @close="showAddSchedule = false" @OnAddSchedule="OnAddedSchedule" v-if="showAddSchedule"></ReserveAddSchedule>
  </v-container>
</template>

<script>
import ReserveAddSchedule from "@/components/reserves/ReserveAddSchedule";
import dayjs from "dayjs";
export default {
  name: "ReserveSchedules",
  components: {ReserveAddSchedule},
  props: ["schedules","readonly"],
  data() {
    return {
      headers: [
        {text: 'Termin', sortable: false, align: 'left', value: 'dateStart'},
        {text: 'Godziny', sortable: false, align: 'left', value: 'startTime'},
        {text: 'Dni', sortable: false, align: 'left', value: 'mon'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      showAddSchedule: false
    }
  },
  methods: {
    deleteItem(itm)
    {
      const index = this.schedules.indexOf(itm)
      if(index > -1)
        this.schedules.splice(index,1)
    },
    OnAddedSchedule(itm) {
      this.schedules.push(itm)
      this.showAddSchedule = false
    },
    getTermin(item)
    {
      if(item.dateStart && item.dateEnd)
      {
        return dayjs(item.dateStart).format('YYYY-MM-DD') + ' - ' + dayjs(item.dateEnd).format('YYYY-MM-DD')
      }
      return 'Dowolny'
    },
    getGodziny(item)
    {
      if(item.startTime && item.endTime)
      {
        return item.startTime + ' - '+item.endTime
      }
      return 'Dowolne godziny'
    },
    getDni(item)
    {
      let dni = []
      if(item.mon)
        dni.push('Pon')
      if(item.tue)
        dni.push('Wto')
      if(item.wed)
        dni.push('Śro')
      if(item.thr)
        dni.push('Czw')
      if(item.fri)
        dni.push('Pią')
      if(item.sat)
        dni.push('Sob')
      if(item.sun)
        dni.push('Nie')

        return dni.join(',')
    }
  },
  computed: {
    schedulesList: {
      get: function() {
        return this.schedules
      },
      set: function(val) {
        this.$emit('update:schedules',val)
      }
    },
  }
}
</script>

<style scoped>

</style>